import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1C1C1C",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M2.75 18.75 7 23.015M4.75 11.75l9.5 9.5m-1.5-13.5.283-.95c.289-.959 1.326-1.74 2.717-2.05.683-.152 1.294-.422 1.77-.782.477-.36.803-.798.945-1.268l.285-.95m-8 2v-3m8.652 7.947L22.75 7.8m-3.461 4.64 2.451 2.45M2.024 18.139l2.125-6.399c.963-2.9 1.444-4.35 2.583-4.62 1.14-.27 2.217.811 4.37 2.973l4.258 4.274c2.146 2.157 3.22 3.236 2.952 4.378-.27 1.143-1.714 1.628-4.603 2.594L7.336 23.47c-3.476 1.164-5.215 1.746-6.133.824-.918-.921-.338-2.667.821-6.157Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "confetti"}) } }